export const STORAGE_TOKEN = 'TOKEN'
export const COOKIE_SESSON_ID = 'JSESSIONID'
